import { Router } from "@frui.ts/screens/dist";

export default class AppRouter extends Router {}
